<template>
    <div class="checkout_redesign--header-wrapper">
        <p class="checkout_redesign--abHeader">{{ headerParams.title }}:</p>
        <p class="checkout_redesign--header">{{ headerParams.subtitle }}</p>
    </div>
</template>

<script>
export default {
    props: {
        headerParams: Object,
    }
}
</script>
